import { SuretyAccountPreview } from "@portal/api/account/agent";
import { SuretyBondPreview } from "@portal/api/bond/agent";
import { BondRequestPreview } from "@portal/api/bond-request/agent";

export enum ActiveFilterEnum {
	ALL = "all",
	ACCOUNTS = "accounts",
	BONDS = "bonds",
	REQUESTS = "bondRequests",
}
export type ActiveFilter = `${ActiveFilterEnum}`;
export type AccountSearchEntity = { relationType: "account"; entity: SuretyAccountPreview };
export type BondRequestSearchEntity = { relationType: "bondRequest"; entity: BondRequestPreview };
export type BondSearchEntity = { relationType: "bond"; entity: SuretyBondPreview };
export type GlobalSearchEntity = AccountSearchEntity | BondRequestSearchEntity | BondSearchEntity;
